import React from 'react'
import { useSelector } from 'react-redux'
import { selectCurrentUser } from '../../../../features/auth/authSlice'

const UserName = () => {
    const user = useSelector(selectCurrentUser)
    return (
        <span className="dropdown-item">
            <i className="uil uil-user-circle font-size-18 align-middle text-muted mr-1"></i>
            <span className="align-middle">{user ? user.name : ''}</span>
        </span>
    )
}

export default UserName
